import { useNavigate } from "react-router-dom";
import { FetchAuditsResponse } from "../../../types/apiResponsesTypes";
import { Audit } from "../../../types/audits";
import GenericTable from "../GenericTable";
import useTableAudits from "./hooks/useTableAudits";

type Props = {
  data: FetchAuditsResponse | undefined;
  fetchData: (queryParams?: string) => void;
  isLoading: boolean;
  onDelete: (id: number) => void;
};

const TableAudits: React.FC<Props> = ({ data, fetchData, isLoading, onDelete }) => {
  const navigate = useNavigate();
  const { columns, onRowClick } = useTableAudits({ navigate, onDelete });

  return (
    <GenericTable<Audit>
      results={data?.results || []}
      count={data?.count || 0}
      columns={columns}
      fetchData={fetchData}
      isLoading={isLoading}
      onRow={onRowClick}
      direction={["descend"]}
    />
  );
};

export default TableAudits;
